/* eslint-disable */ 
import fileService from '@/shared/file/file-service';
import logService from '@/shared/entity-logger';
import { db, firebase } from '@/shared/firebase/firebase-init';
import teamManagerModel from './team-manager-model';
import moment from 'moment';    // birthdate
import _ from 'underscore'        // export pdf
import * as jsPDF from 'jspdf';   // export pdf
import 'jspdf-autotable';         // export pdf

const KEY_TEAM_MANAGERS = 'teamManagers'
const KEY_TEAMS = 'teams'
const NAME_ENTITY= 'team-manager'
const KEY_CLUBS= 'clubs'

export default {

  list() {
    return new Promise((resolve) => {
      db.ref(KEY_TEAM_MANAGERS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  },

  listByTeamId(teamId) {
    return new Promise((resolve) => {
      db.ref(KEY_TEAMS).child(teamId).child(KEY_TEAM_MANAGERS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  },


  save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },

  find(id) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line
      db.ref(KEY_TEAM_MANAGERS).child(id).once('value').then((snapshot) => { 
        const model = snapshot.val();
        
        if (!model) {
          return null;
        }
        
        // Si no tiene picture
        if (model.picture.name === "") {
          resolve(model)
        }

        fileService.fillDownloadURL(
          KEY_TEAM_MANAGERS,
          model.id,
          'picture',
          model.picture
        ).then(() => {
          resolve(model)
        }).catch((error) => {
          reject(error)
        });
      })
    });
  },

  destroy(model, loggedUser) {
    const modelToDestroy = {
      ...model,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      deleted:  firebase.database.ServerValue.TIMESTAMP,
      deletedBy:  { id: loggedUser.id, email: loggedUser.email },
      modifiedBy:  { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      var updates = {};
      updates['/' + KEY_TEAMS + '/' + model.team.id + '/' + KEY_TEAM_MANAGERS + '/'+ model.id] = null;
      updates['/' + KEY_TEAM_MANAGERS + '/' + model.id ] = null;
      updates['/' + KEY_CLUBS + '/' + model.team.club.id + '/' + KEY_TEAMS + '/' + model.team.id + '/' + KEY_TEAM_MANAGERS + '/'+ model.id] = null;

      db.ref().update(updates, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {
          // Data deleted successfully!
          fileService.delete(KEY_TEAM_MANAGERS, model.id, 'picture', model.picture)
          .then(() => {
              // Logs 
              logService.log(modelToDestroy, "deleted", KEY_TEAM_MANAGERS, NAME_ENTITY)
              resolve()
            }).catch((error) => {
              reject(error)
            });
        }
      })
    })
  },

  update(model, loggedUser) {
    const modelToUpdate = {
      ...model,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      fileService.uploadB64Img(KEY_TEAM_MANAGERS, modelToUpdate.id, 'picture', modelToUpdate.picture)
        .then(() => {
          var updates = {};
          updates['/' + KEY_TEAMS + '/' + model.team.id + '/' + KEY_TEAM_MANAGERS + '/'+ model.id] = teamManagerModel.forTeam(modelToUpdate);
          updates['/' + KEY_TEAM_MANAGERS + '/' + model.id ] = teamManagerModel.forUpdate(modelToUpdate);
          updates['/' + KEY_CLUBS + '/' + model.team.club.id + '/' + KEY_TEAMS + '/' + model.team.id + '/' + KEY_TEAM_MANAGERS + '/'+ model.id] = teamManagerModel.forTeam(modelToUpdate);
  
          db.ref().update(updates, (error) => {            if (error) {
              // The write failed...
              reject(error)
            } else {
              // Data saved successfully!
              // Logs
              logService.log(modelToUpdate, "modified", KEY_TEAM_MANAGERS, NAME_ENTITY)
              resolve()
            }
          })
        }).catch((error) => {
          reject(error)
        });
      });
  },

  create(model, loggedUser) {
    const modelToSave = {
      ...model,
      id: db.ref(KEY_TEAM_MANAGERS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email } ,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };
    console.log("<--- CREATE PLAYER");
    console.log(modelToSave);
    

    return new Promise((resolve, reject) => {
      
      fileService.uploadB64Img(KEY_TEAM_MANAGERS, modelToSave.id, 'picture', modelToSave.picture)
      .then(() => {
        var updates = {};
        updates['/' + KEY_TEAMS + '/' + model.team.id + '/' + KEY_TEAM_MANAGERS + '/'+ modelToSave.id] = teamManagerModel.forTeam(modelToSave);
        updates['/' + KEY_TEAM_MANAGERS + '/' + modelToSave.id ] = teamManagerModel.forCreate(modelToSave);
        updates['/' + KEY_CLUBS + '/' + model.team.club.id + '/' + KEY_TEAMS + '/' + model.team.id + '/' + KEY_TEAM_MANAGERS + '/'+ modelToSave.id] = teamManagerModel.forTeam(modelToSave);

        db.ref().update(updates, (error) => {
          if (error) {
            // The write failed...
            reject(error)
          } else {
            // Data saved successfully!
            // Logs
            logService.log(modelToSave, "created", KEY_TEAM_MANAGERS, NAME_ENTITY)
            resolve()
          }
        });
      }).catch((error) => {
        reject(error)
      });
    });
  },
  exportAsPDF (list) {
    return new Promise((resolve, reject) => {
      /**
       * COACHES PARSING
       */

      var coachDataList = []
      var coachHeaderList = [
        [ 'Nombre','Apellidos', 'Teléfono', 'Equipo', 'Categoría']
      ]
      
     // Coaches
      const listMapped = _.map(list, (item) => {
        return {...item, teamName: item.team.name}
      })

      // Oredenar por nombre del equipo
      _.each(_.sortBy(listMapped, 'teamName'), (coach, key, list) => {
        // var birthdate =  moment( coach.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [coach.name,coach.lastName,coach.phone, coach.team.name, coach.team.category.label]
        coachDataList.push(values)
      })
      
      /*************************************************************
       *                                                           *
       *                CREAACION DEL DOC PDF                      *
       *                                                           *
       *************************************************************/

      var doc = new jsPDF()
      var docName = 'Delegadore_De_Equipo_' + moment().format('DD-MM-YYYY') + '.pdf'
      var docTitle = "Delegados de equipo " 
      
      doc.setFontSize(22);
      doc.text(docTitle, 14, 20);
      doc.setFontSize(12);

      var img = new Image();
      img.addEventListener('load', function() {
         // doc.addImage(img, 'png', 10, 50);
      });
      img.src = '/static/logos/logo_dv7.png';
      doc.addImage(img, 'JPEG', 155, 12 , 40, 20);

       // Coaches data
      //  Labels
      doc.text("Fecha:", 14, 35);
      doc.text("Nº de delegados:", 14, 40);

      doc.text(moment().format('DD/MM/YYYY'), 60, 35);
      doc.text(`${_.size(list)}`, 60, 40);

      // Coaches
      doc.setFontSize(14);
      // doc.text("Entrenadores", 14,  60);
      doc.autoTable({ head: coachHeaderList, body: coachDataList,   startY: 65,  theme: 'plain', styles: {cellPadding: 0.5, fontSize: 10, halign: 'center' } });
     
      doc.save(docName);
      resolve()
    });
  },

  listOptions() {
    return new Promise((resolve) => {
      db.ref(KEY_TEAM_MANAGERS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          const modelOption = {}
          modelOption.id = childSnapshot.key
          modelOption.label = childSnapshot.val().name

          list.push(modelOption)
        });
        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/team-manager/team-manager-service.js